import { ITransferCoursesDatasource } from './../datasources/transfer_courses_datasource';
import { QueryMediator } from './../../../vendor/utility-ng-kernel/dist/core/query_mediator';
import { Course } from './../builders/course_builder';
import { IDefineCommand, IQueryMediator, ICommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';

angular.module('capability-ng-transfer').factory(
  'updateTransferStudentCourseCommand',
  (
    defineCommand: IDefineCommand,
    QueryMediator: IQueryMediator,
    ngTransferCoursesDatasource: ITransferCoursesDatasource,
    $http: ng.IHttpService,
    transferMajorTileDelegate: any
  ): ICommand => {
    return defineCommand('updateTransferStudentCourseCommand', (deferred: ng.IDeferred<IQuery[]>, course: Course) => {
      const url = `student/college/${course.college_nk}/course/${course.id}/`;
      $http({
        method: 'patch',
        url: url,
        data: {
          grade: course.grade,
          credits: _4.isString(course.credits) && course.credits.trim() === '' ? null : course.credits,
          term_type: course.term_type,
          term_year: _4.isString(course.term_year) && course.term_year.trim() === '' ? null : course.term_year
        }
      })
        .then((response: ng.IHttpPromiseCallbackArg<any>) => {
          transferMajorTileDelegate.updateDegreeAudit();
          QueryMediator.runQueries(ngTransferCoursesDatasource);
          deferred.resolve();
        })
        .catch(deferred.reject);
    });
  }
);



// WEBPACK FOOTER //
// ./app/lib/transfer/commands/update_transfer_student_course_command.ts